<script setup lang="ts">
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { INVENTORY_DASHBOARD_PATH } from '../constants';

const t = i18n.t;
</script>
<template>
  <div class="page-wrap">
    <div class="header">
      <RouterLink :to="INVENTORY_DASHBOARD_PATH" class="ignore-hover">
        <Mdi icon="arrow_back" variant="round" />
      </RouterLink>
      <div class="header__title">
        {{ t('ダッシュボード') }}
      </div>
    </div>
    <slot />
  </div>
</template>
<style lang="scss" scoped>
.page-wrap {
  padding: 16px 16px 0 16px;
  height: 100%;
  *:not(.material-icons) {
    font-family: Noto Sans JP;
  }
  display: grid;
  grid-template-rows: repeat(2, fit-content(100%));
  gap: 16px;
  min-width: 0;
}
.header {
  display: grid;
  grid-template-columns: max-content max-content;
  align-items: center;
  gap: 8px;
  &__title {
    color: $textDefault;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.23;
  }
}

a {
  &:hover,
  &:focus,
  &:focus-visible {
    color: inherit !important;
    background-color: inherit !important;
  }
}
</style>
